export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/marketing.4e506088-6dacf1.png";